import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  lotsHeaderContent: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',

    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      alignItems: 'start'
    }
  },

  buttonContainer: {
    display: 'flex',
    paddingLeft: theme.app.spacing.base,
    gap: theme.app.spacing.md,

    [theme.breakpoints.down('sm')]: {
      padding: `${theme.app.spacing.base}px 0`,
      width: '100%',
      flexDirection: 'column'
    }
  },

  buttonWrapper: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.app.spacing.sm,
    padding: `${theme.app.spacing.sm}px ${theme.app.spacing.base}px`,

    [theme.breakpoints.down('sm')]: {
      width: '100%',
      justifyContent: 'center'
    }
  },

  lotsContainer: {
    width: '100%',
    paddingRight: theme.app.spacing.base,
    minHeight: 400
  },

  loadingContainer: {
    width: '100%',
    height: 400,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },

  emptyState: {
    width: '100%',
    height: 420,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 20,
    border: '1px dashed #E0E0E0',
    borderRadius: theme.app.borderRadius.xl,
    backgroundColor: theme.app.colors.text.light
  },

  emptyStateIcon: {
    width: 72,
    height: 72,
    borderRadius: '50%',
    backgroundColor: theme.palette.primary.main + '15',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',

    '& svg': {
      color: theme.palette.primary.main,
      opacity: 0.8
    }
  },

  emptyStateContent: {
    textAlign: 'center',
    maxWidth: 420,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: theme.app.spacing.md
  },

  emptyStateTitle: {
    margin: 0,
    fontSize: 22,
    fontWeight: 600,
    color: '#2E2E2E'
  },

  emptyStateDescription: {
    margin: 0,
    fontSize: 14,
    color: '#6D6D6D',
    lineHeight: 1.5
  },

  emptyStateButton: {
    marginTop: theme.app.spacing.sm,
    padding: '10px 20px',
    borderRadius: theme.app.borderRadius.md,
    textTransform: 'none',
    fontWeight: 500
  },

  animalCount: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.app.spacing.sm,
    padding: `${theme.app.spacing.sm}px ${theme.app.spacing.base}px`,
    backgroundColor: theme.palette.primary.main + '10',
    borderRadius: 20
  },

  countLabel: {
    fontSize: theme.app.typography.label.fontSize,
    color: theme.app.colors.text.secondary,
    fontWeight: 400
  },

  countValue: {
    fontSize: theme.app.typography.h3.fontSize,
    fontWeight: 600,
    color: theme.palette.primary.main
  }
}))
